import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IReportItem } from '@interfaces/interfaces';
import { SessionItemData } from '@workflow/services/session-item-data';
import { ContentBlockReportItem } from '@interfaces/reports';
import { Subscription } from 'rxjs';
import { ActiveParticipantService } from '@app/services/participants/active-participant.service';
import { InterpolationService } from '@app/services/interpolation/interpolation.service';

@Component({
	selector: 'workflow-content-block-report',
	templateUrl: './content-block-report.component.html',
	styleUrls: ['./content-block-report.component.scss']
})
export class ContentBlockReportComponent implements OnInit, OnDestroy {

	@Input() report: IReportItem;
	@Input() data: SessionItemData;

	interpolatedText: string;
	subscription = new Subscription();

	constructor(private participantService: ActiveParticipantService,
				private interpolationService: InterpolationService) {
	}

	ngOnInit(): void {
		if (this.report && this.data) {
			this.subscription.add(this.participantService.participant$.subscribe(participant => {
				const contentBlockReport = this.report as ContentBlockReportItem;
				const interpolationContext: unknown = {
					data: this.data.data,
					participant: participant.data
				};
				this.interpolatedText = this.interpolationService.interpolate(contentBlockReport.content, interpolationContext);
			}));
		}
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}
